import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  public readonly isLoading = signal(false);
  public readonly message = signal('Cargando...');
  private requestCount = 0;

  show(message?: string): void {
    this.requestCount++;
    if (this.requestCount === 1) {
      this.message.set(message || 'Cargando...');
      this.isLoading.set(true);
    }
  }

  hide(): void {
    if (this.requestCount > 0) {
      this.requestCount--;
    }

    if (this.requestCount === 0) {
      this.isLoading.set(false);
      this.message.set('Cargando...');
    }
  }
}
